import { Layout } from "@introist/react-foundation/v2";
import { ConnectFormProps } from "../views/DataSourceConnectionSetupView/steps/DataSourceConnectionForm";
import { GenericPersonioFields } from "./personio";

export const PersonioV2ConnectForm = ({ values, onChange }: ConnectFormProps) => {
  return (
    <Layout.Group vertical gap="xLarge">
      <GenericPersonioFields values={values} onChange={onChange} />
    </Layout.Group>
  );
};
